module.exports = __webpack_public_path__ + "static/media/rBurr.02be8c96.jpeg";